
import { loadCourseData, loadCoursesData } from "~/utils/course-loader.server";
import type { Route } from "./+types/layout";
import { isRouteErrorResponse, Outlet, useRouteError, useRouteLoaderData } from "react-router";
import NotFound from "./not-found";
import type { Course } from "~/models/course";
import { getTitleTemplate, canonical } from "~/utils/meta";

export async function loader({ params }: Route.LoaderArgs) {
  const ctid = params.ctid ?? 'all';
  const cid = params.courseId ?? null
  let courses: Course[] | undefined;
  let courseDetails: Course | null = null;
      if(!cid) {
        courses = await loadCoursesData(ctid);
      } else  {
        courseDetails = await loadCourseData(cid);
      }
  return { courses, courseDetails, ctid };
}

export default function CoursesLayout() {
  return <Outlet />;
}

export function ErrorBoundary() {
  const error = useRouteError();

  // ✅ Log the full object, with stack trace if available
  console.error("Error Boundary:", error);

 

  if (isRouteErrorResponse(error) && error.status === 404) {
    return <NotFound />;
  } 
  
  if (error instanceof Error) {
    // You can also log specific fields
    console.error("Message:", error.message);
    console.error("Stack:", error.stack);
    throw error;
  }

  return <NotFound />;
}

export function meta({ matches }: Route.MetaArgs) {
  const tpl = getTitleTemplate(matches);
  const title = tpl("All Courses");
  const desc = "Browse all Constellation Training courses across First Aid, Mental Health First Aid, and Health & Safety.";

  return [
    { title },
    { name: "description", content: desc },
    { property: "og:title", content: title },
    { property: "og:description", content: desc },
    { name: "twitter:title", content: title },
    { name: "twitter:description", content: desc },
    { tagName: "link", rel: "canonical", href: canonical("/courses") },
  ];
}


// Children can read parent data via:
export function useCoursesData() {
  return useRouteLoaderData("courses-layout") as Route.ComponentProps["loaderData"];
}